import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import exportSmallTokens from '@amzn/meridian-tokens/base/icon/export-small';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { TertiaryButton } from 'src/common/buttons';
import { useOffRampToAmazon, usePageContext } from 'src/hooks';
export const SeeMoreOnAmazonButton = ({ offRampUrl }) => {
    const { commonBundle: bundle } = usePageContext();
    const offRampToAmazon = useOffRampToAmazon();
    const onSeeMoreButtonClick = () => {
        offRampToAmazon(offRampUrl, ReportActionSource.BuyBox);
    };
    return (_jsx(TertiaryButton, { onClick: onSeeMoreButtonClick, shape: "small", "data-testid": "see-more-on-amazon-button", children: _jsxs(Row, { spacing: "300", children: [_jsx("span", { children: bundle.getMessage('seeMoreOnAmazon') }), _jsx(Icon, { tokens: exportSmallTokens })] }) }));
};
